import useWindowDimensions from "./useWindowDimensions";
import { debounce } from "lodash-es";
import { useMemo } from "react";
import scssVariables from "../../assets/styles/export.module.scss";

const { baseFontSize, baseComponentWidth } = scssVariables;

export default function useBaseFontResize(): void {
  const { width } = useWindowDimensions();

  const updateFontSize = (fontSize: number): void => {
    document.documentElement.style.setProperty("font-size", `${fontSize}px`);
  };

  const debounceFontSizeUpdate = useMemo(
    () =>
      debounce(
        (width) =>
          updateFontSize(width < baseComponentWidth ? (baseFontSize / baseComponentWidth) * width : baseFontSize),
        20
      ),
    []
  );

  debounceFontSizeUpdate(width);
}
